import { render, staticRenderFns } from "./CustomTextStylesEditor.vue?vue&type=template&id=26468f4a&scoped=true"
import script from "./CustomTextStylesEditor.vue?vue&type=script&lang=js"
export * from "./CustomTextStylesEditor.vue?vue&type=script&lang=js"
import style0 from "./CustomTextStylesEditor.vue?vue&type=style&index=0&id=26468f4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26468f4a",
  null
  
)

export default component.exports